import React from 'react';

const SkeletonLoader = ({ type = 'card', count = 1 }) => {
  const items = Array.from({ length: count });

  if (type === 'stats') {
    return (
      <div className="cp-stats-grid">
        {items.map((_, i) => <div key={i} className="cp-skeleton cp-skeleton-stat" />)}
      </div>
    );
  }

  if (type === 'table-row') {
    return items.map((_, i) => (
      <tr key={i}>
        <td colSpan="10"><div className="cp-skeleton cp-skeleton-text" style={{ width: `${60 + Math.random() * 30}%` }} /></td>
      </tr>
    ));
  }

  if (type === 'text') {
    return items.map((_, i) => (
      <div key={i} className="cp-skeleton cp-skeleton-text" style={{ width: `${50 + Math.random() * 40}%` }} />
    ));
  }

  return items.map((_, i) => <div key={i} className="cp-skeleton cp-skeleton-card" />);
};

export default SkeletonLoader;
